export const ORDER_RECEIPT_PROMOTE_ORDER_FAILURE =
  'ORDER_RECEIPT_PROMOTE_ORDER_FAILURE'
export const ORDER_RECEIPT_PROMOTE_ORDER_PENDING =
  'ORDER_RECEIPT_PROMOTE_ORDER_PENDING'
export const ORDER_RECEIPT_PROMOTE_ORDER_SUCCESS =
  'ORDER_RECEIPT_PROMOTE_ORDER_SUCCESS'
